const NOT_AUTHENTICATED: string = 'NOT_AUTHENTICATED';

export { NOT_AUTHENTICATED };
